<template>
  <div class="prescriptionDetails">
    <el-page-header @back="goBack" content="处方详情"></el-page-header>
    <div class="prescriptionDetails_content">
      <!-- 一级药师拒绝原因字段显示 -->
      <el-card
        class="status_card"
        v-if="userInfo.status === 3 || userInfo.status === 4"
      >
        <div>
          <el-tag
            type="danger"
            class="prescription_type"
            effect="dark"
            size="medium"
            disable-transitions
            ><span class="prescription_status">{{
              userInfo.status_dictText
            }}</span></el-tag
          >

          <div class="prescription_reason">
            原因：{{ userInfo.prescriptionCause }}
          </div>
        </div>
      </el-card>
      <!-- 二级药师拒绝原因字段显示 -->
      <el-card
        class="status_card"
        v-if="userInfo.status === 7 || userInfo.status === 8"
      >
        <div>
          <el-tag
            type="danger"
            class="prescription_type"
            effect="dark"
            size="medium"
            disable-transitions
            ><span class="prescription_status">{{
              userInfo.status_dictText
            }}</span></el-tag
          >

          <div class="prescription_reason">
            原因：{{ userInfo.drugsCause }}
          </div>
        </div>
      </el-card>

      <caseDetail v-if="userInfo.patient && userInfo.patient.id" :userInfo="userInfo" :imgList="imgList"></caseDetail>
      <div class="prescription_html">
        <span v-html="prescriptionHtml"></span>
      </div>
    </div>
  </div>
</template>

<script>
// import { prescriptionDetail } from "@/api";
import { caseQueryById, getPrescriptionForm } from "@/api/doctor";
import util from "@/utils";
import emptyData from "@/components/common/emptyData.vue";
import prescriptionPdf from "@/components/prescriptionPdf";
import caseDetail from "@/components/case/detail";
import auditBtn from '@/components/common/auditBtn'

export default {  
  name: "",
  components: { emptyData, prescriptionPdf, caseDetail,auditBtn },
  props: {},
  data() {
    return {
      imgList: [], // 处理加密的图片
      userInfo: {},
      id: this.$route.query.id,
      case_id: this.$route.query.case_id,
      prescriptionHtml: "",
    };
  },
  mounted() {
    this.getUserInfo()
    this.getPrescription();
  },
  methods: {
    goBack() {
      const that = this;
      that.$router.go(-1); //返回上一层
    },
    //获取病例详情
    async getUserInfo() {
      const params = {
        orderNo: this.$route.query.orderNo,
      }
      const res = await caseQueryById(params)
      if(res.code == 1){
        this.userInfo = res.data;

        // 附件
        let casesSymptom = this.userInfo.cases.symptom;
        if (casesSymptom && casesSymptom.indexOf(",") != -1) {
          this.imgList = casesSymptom.split(",");
        } else {
          casesSymptom && this.imgList.push(casesSymptom);
        }
      }
    },
    /**
     * 获取处方单html
     */
    async getPrescription() { 
      const params = {
        recipeId: this.$route.query.id,
      };

      const res = await getPrescriptionForm(params);
      if (res.code == 1) {
        this.prescriptionHtml = res.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.prescriptionDetails {
  .status_card {
    float: right;
    width: 20%;
    top: 130px;
    right: 40px;
    padding-top: 20px;
    z-index: 100;
    display: block;
    text-align: center;
    vertical-align: middle;
    position: fixed;
    .prescription_type {
      display: inline-block;
      // float: left;
      // text-align: center;
      width: 100%;
    }
    .prescription_reason {
      text-align: left;
      padding: 8px;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .empty {
    width: 10%;
    margin: 0 auto;
    margin-top: 10%;
  }
  .prescription_html{
    margin-top: 20px;
  }
}
</style>
